/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 * A directive that ensures elements  order is correct hierarchically as per narrator focusorder.
 *
 * @example
 <div class="bulb-sign-in" bulb-taborder>
 *
 */
angular.module('bulbApp.utilsModule')

.directive('bulbTaborder',['$interval', 'BulbBrowserService', function ($interval, BulbBrowserService) {
  return {
        restrict: 'A',
    link: function(scope, div) {
      /**
      * Checking every 100ms to see when the div has been rendered,
      * and then fixing it for taborder and focus indication.
      */
      var counter = 0;
      var watchForTabsetRender = $interval(function() {
        if (counter < 50) {
          counter++;
          var elements = div.find('input, textarea, button, form, a, h1, label[role="button"], article, figure');
          if (elements.length > 0) {
            for(var i = 0; i < elements.length; i++) {
              var focusableElement = $(elements[i]);
              /** Anchor tag accessibility management,
               * this code will make anchor focusable and clickable.
               */
              if (focusableElement.length === 1 && focusableElement.is('a') &&
                !focusableElement.hasClass('error-icon-tooltip') &&
                !focusableElement.hasClass('bulb-header-icon')) {
                var anchorClass = focusableElement.attr('class');
                if(anchorClass && anchorClass.includes('error')) {
                  continue;
                }
                focusableElement.attr('tabindex','0');
                if(focusableElement.attr('href') === undefined) {
                  focusableElement.attr('href','javascript:void(0);');// jshint ignore:line
                }
              }
              /** Checking that the browser is ms edge or not,
               * if so then furthur implementation will handle reverse and forward tabbing
               */
              if(BulbBrowserService.isMsEdge()) {
                /** Workaround for narrator cursor missplacing correction
                 *  this will prevent narrator cursor wrong jumping to element
                 */
                if (focusableElement.length === 1) {
                  var applicableElement = true;
                  if(focusableElement.is('a') && (focusableElement.hasClass('error-icon-tooltip') || focusableElement.hasClass('sign-up-page-error-icon-tooltip'))) {
                    applicableElement = false;
                  } else if(focusableElement.is('button') && (focusableElement.hasClass('button-clever') || focusableElement.hasClass('button-microsoft') || focusableElement.hasClass('button-google') || focusableElement.hasClass('bulb-page-cover-image-upload-button'))) {
                    applicableElement = true;
                  } else if (focusableElement.is('button') && (focusableElement.attr('type') === 'submit' || focusableElement.attr('ng-click') !== undefined)){
                    applicableElement = false;
                  }
                  if(applicableElement) {
                      if(focusableElement.is('input')) {
                        focusableElement.on('click', function(event) { // jshint ignore:line
                          handleTab(event,true);
                        });
                      } else if(focusableElement.is('textarea')) {
                        focusableElement.on('change keyup paste', function(event) { // jshint ignore:line
                          handleTab(event, true);
                        });
                      } else if(focusableElement.is('button')) {
                        focusableElement.on('focus', function(event) { // jshint ignore:line
                          handleTab(event,true);
                        });
                      } else {
                        focusableElement.on('focus', function(event) { // jshint ignore:line
                          handleTab(event, true);
                        });
                      }
                      focusableElement.on('blur', function(event) { // jshint ignore:line
                        handleTab(event, false);
                      });
                  }
                }
              }

            }
            $interval.cancel(watchForTabsetRender);
          }

        } else {
          $interval.cancel(watchForTabsetRender);
        }
      }, 100);

      /**
       * A function that manage element taborder and narrator cursor only for ms edge browser
       * @param {*} event
       * A function that contains element event
       * @param {*} direction
       * A function that manage element taborder and narrator cursor only for ms edge browser
       */
      function handleTab(event, direction) {
        var bulbMainDiv = $('.bulb-main');
        var bulbMainParentDiv = bulbMainDiv.parent();
        if(direction) {
          if(!bulbMainParentDiv.hasClass('bulb-aria-hide')) {
            bulbMainParentDiv.addClass('bulb-aria-hide');
          }
          if(bulbMainParentDiv.attr('aria-hidden') === undefined) {
            bulbMainParentDiv.attr('aria-hidden','true');
          }
          if(!bulbMainDiv.hasClass('bulb-aria-reshow')) {
            bulbMainDiv.addClass('bulb-aria-reshow');
          }
          if(bulbMainDiv.attr('aria-hidden') === undefined) {
            bulbMainDiv.attr('aria-hidden','false');
          }
        } else {
          if(bulbMainParentDiv.hasClass('bulb-aria-hide')) {
            bulbMainParentDiv.removeClass('bulb-aria-hide');
          }
          if(bulbMainParentDiv.attr('aria-hidden') !== undefined) {
            bulbMainParentDiv.removeAttr('aria-hidden');
          }
          if(bulbMainDiv.hasClass('bulb-aria-reshow')) {
            bulbMainDiv.removeClass('bulb-aria-reshow');
          }
          if(bulbMainDiv.attr('aria-hidden') !== undefined) {
            bulbMainDiv.removeAttr('aria-hidden');
          }
        }
        // if element is radio or checkbox then skip prevent default
        var currentElement = $(event.currentTarget);
        var skipPreventDefault = false;
        if(currentElement.is('input')) {
          var type = currentElement.attr('type');
          if(type === 'radio' || type === 'checkbox') {
            skipPreventDefault = true;
          }
        }
        if(!skipPreventDefault) {
          event.preventDefault();
        }
        return false;
      }
    }
  };
}]);
